"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCancel = void 0;

var _VideoPlayer = require("../../VideoPlayer");

var _UploadMomentHeader = require("../UploadMomentHeader");

var _CancelUploadFooter = require("../CancelUploadFooter");

var _StepController = require("../../../molecules/StepController");

var _atoms = require("../../../atoms");

var _VideoPreview = require("../VideoPreview");

var _react = _interopRequireWildcard(require("react"));

require("./StepCancel.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Step Cancel
var StepCancel = function StepCancel(_ref) {
  var name = _ref.name,
      updates = _ref.updates,
      tempMoment = _ref.tempMoment,
      canPlayLocalVideo = _ref.canPlayLocalVideo,
      onAbortCancelClick = _ref.onAbortCancelClick,
      showContentInMobile = _ref.showContentInMobile,
      onConfirmCancelClick = _ref.onConfirmCancelClick;

  var handleAbortCancelClick = function handleAbortCancelClick() {
    if (typeof onAbortCancelClick === "function") {
      onAbortCancelClick();
    }
  };

  var handleConfirmCancelClick = function handleConfirmCancelClick() {
    if (typeof onConfirmCancelClick === "function") {
      onConfirmCancelClick();
    }
  }; // Handle display of content in mobile


  var showContentInMobileClassName = !showContentInMobile ? "mobile-hide" : ""; // Video timing & spotlight logic

  var momentDuration = updates.stopAtRelative - updates.startAtRelative; // Get video container ref

  var videoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();

  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(videoPlayerContainerRef),
      duration = _useVideoInfo.duration;

  if (updates.startAtRelative === 0 && updates.stopAtRelative === 0) {
    momentDuration = duration;
  }

  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "StepCancel upload-moment-preview-container",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Row
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-preview ".concat(showContentInMobileClassName)
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    title: "Cancel upload",
    className: "mobile",
    showCloseButton: false
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "upload-moment-video-container"
  }, /*#__PURE__*/_react.default.createElement(_VideoPreview.VideoPreview, {
    moment: tempMoment,
    updates: updates,
    duration: momentDuration,
    containerRef: videoPlayerContainerRef
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-controls",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    title: "Cancel upload",
    className: "desktop",
    showBackButton: false
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-step-content",
    justifyContent: "flex-start",
    alignItems: "center"
  }, "By closing this modal none of your progress will be saved. Do you want to cancel this upload?")), /*#__PURE__*/_react.default.createElement(_CancelUploadFooter.CancelUploadFooter, {
    onAbortCancelClick: handleAbortCancelClick,
    onConfirmCancelClick: handleConfirmCancelClick,
    canPlayLocalVideo: canPlayLocalVideo
  }))));
};

exports.StepCancel = StepCancel;
StepCancel.defaultProps = {
  showContentInMobile: true
};